/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdNoticeBarProps } from './type';

export const noticeBarDefaultProps: TdNoticeBarProps = {
  direction: 'horizontal',
  marquee: false,
  theme: 'info',
  defaultVisible: false,
};
